export interface FilterItem {
  name: string;
  currentOption: number | string;
  options: (number | string)[];
}

export interface ParametersObject {
  depth?: number;
  diagnostic_type?: string;
  domain?: string;
}

export const createParametersObject = (
  parameters: FilterItem[],
): ParametersObject =>
  parameters.reduce(
    (acc, p) => ({ ...acc, [p.name]: p.currentOption }),
    {} as ParametersObject,
  );

export const getCurrentIndex = (param: FilterItem) =>
  param.options.indexOf(param.currentOption);

export const canMove = (param: FilterItem, direction: 'previous' | 'next') => {
  const currentIndex = getCurrentIndex(param);
  return direction === 'previous'
    ? currentIndex > 0
    : currentIndex < param.options.length - 1;
};

export const getNextValue = (
  param: FilterItem,
  direction: 'previous' | 'next',
) => {
  const currentIndex = getCurrentIndex(param);
  return direction === 'previous'
    ? param.options[currentIndex - 1]
    : param.options[currentIndex + 1];
};

export const resetFollowingParams = (
  parameters: FilterItem[],
  startIndex: number,
  direction: 'previous' | 'next',
) =>
  parameters.slice(startIndex).reduce(
    (acc, param) => ({
      ...acc,
      [param.name]:
        direction === 'previous'
          ? param.options[param.options.length - 1]
          : param.options[0],
    }),
    {},
  );
